import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3123564e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "search-view"
};
import { nextTick, ref, computed } from 'vue';
import composition from '@/composition';
import debounce from 'lodash/debounce';
export default {
  props: {
    cid: Number,
    canEdit: Boolean
  },
  emits: ['selectTag'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;

    var _composition = composition(),
        request = _composition.request; // 是否展示


    var show = ref(false); // 结果数组

    var results = ref([]); // 搜索内容

    var searchValue = ref('');
    var isShowCell = computed(function () {
      return function (name) {
        return name.indexOf(searchValue.value) != -1;
      };
    });

    function openSheet() {
      if (!props.canEdit) {
        return;
      }

      show.value = true;
      nextTick(function () {
        document.getElementById('searchView').scrollTop = 0;
      });
      request.getTimelineTags(props.cid, {}).then(function (res) {
        results.value = res.data;
      });
    } // 选择话题


    function selectTag(item) {
      if (!item) {
        // 不显示
        results.value = [];
        searchValue.value = '';
      }

      emits('selectTag', item);
      show.value = false;
    } // 输入


    var handleChange = debounce(function (value) {
      searchValue.value = value;
    }, 500);
    return function (_ctx, _cache) {
      var _component_van_search = _resolveComponent("van-search");

      var _component_van_cell = _resolveComponent("van-cell");

      var _component_van_action_sheet = _resolveComponent("van-action-sheet");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "open-btn",
        onClick: openSheet
      }, [_renderSlot(_ctx.$slots, "default")]), _createVNode(_component_van_action_sheet, {
        class: "search-sheet",
        id: "searchView",
        show: show.value,
        "onUpdate:show": _cache[2] || (_cache[2] = function ($event) {
          return show.value = $event;
        }),
        title: "选择话题"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_search, {
            onInput: _cache[0] || (_cache[0] = function ($event) {
              return _unref(handleChange)($event.target.value);
            }),
            placeholder: "输入想要添加的话题",
            shape: "round",
            clearable: false
          }), _createVNode(_component_van_cell, {
            title: "不使用",
            clickable: true,
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return selectTag();
            })
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, function (item) {
            return _withDirectives((_openBlock(), _createBlock(_component_van_cell, {
              key: item.id,
              title: '#' + item.name + '#',
              "title-class": "publish-tag-title",
              clickable: true,
              onClick: function onClick($event) {
                return selectTag(item);
              }
            }, null, 8, ["title", "onClick"])), [[_vShow, _unref(isShowCell)(item.name)]]);
          }), 128))])];
        }),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};